import { AnimationClassNames } from '@uifabric/styling';
import { IBreadcrumbItem } from 'office-ui-fabric-react/lib/Breadcrumb';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { getTheme } from 'office-ui-fabric-react/lib/Styling';
import { withViewport } from 'office-ui-fabric-react/lib/utilities/decorators/withViewport';
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { updateBreadCrumbs } from '../../../redux/Actions/BreadCrumbs/ActionCreators';
import { IRootState } from '../../../redux/Reducers/RootReducer';

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    updateBreadCrumbs: (items: IBreadcrumbItem[]) => dispatch(updateBreadCrumbs(items))
  };
};

const mapStateToProps = (state: IRootState, ownProps: any) => {
  return { security: state.securityState.security };
};

@withViewport
class Home extends React.PureComponent<any, any> {
  public componentDidMount() {
    const { t } = this.props;
    const items: IBreadcrumbItem[] = [{ text: t('home.breadcrumb.home'), key: 'home', isCurrentItem: true }];
    this.props.updateBreadCrumbs(items);
  }

  public render(): JSX.Element {
    return (
      <Fabric className="ms-Grid">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col" style={{ textAlign: 'center', width: '100%', paddingTop: '30px' }}>
            <br />
            <span className={`ms-font-su ${AnimationClassNames.fadeIn500}`} style={{ color: getTheme().palette.themePrimary }}>
              {this.props.t('Welcome to KTX React')}
            </span>
          </div>
        </div>
      </Fabric>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Home));
